<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container job-copy-week-modal">
          <div class="modal-header">
            <slot name="header">
              Copy Week
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-6">
                  <label for="round">Copy Week {{ week_index + 1 }} to: </label>
                </div>
                <div class="col-6">
                  <select
                    class="form-control"
                    ref="schedule_round_week"
                    v-model="selected_week"
                  >
                    <option
                      v-for="index in Number(
                        schedules[schedule_index].duration,
                      )"
                      :value="index - 1"
                      v-bind:key="index"
                      :disabled="index - 1 == week_index"
                      >Week {{ index }}</option
                    >
                  </select>
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Copy
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ScheduleCopyWeek",
  props: {
    schedule_index: {
      type: Number,
      required: true,
    },
    week_index: {
      type: Number,
      default: -1,
    },
  },
  data: () => ({
    selected_week: -1,
  }),
  computed: {
    ...mapState("schedule", ["schedules"]),
  },
  mounted: function() {
    this.$nextTick(function() {
      this.selected_week = this.week_index;
    });
  },
  methods: {
    ...mapActions("schedule", ["copyWeekTo"]),
    _save() {
      if (this.selected_week < 0) {
        alert("please select a week");
        return;
      } else if (this.selected_week == this.week_index) {
        alert("please select a different week");
        return;
      }
      this.copyWeekTo({
        schedule_index: this.schedule_index,
        from_week: this.week_index,
        to_week: this.selected_week,
      });
      this.$emit("close");
    },
  },
  watch: {},
  components: {},
};
</script>
